import React, { useEffect, useState } from 'react';
import { Modal } from 'reactstrap';
import { platforms } from 'constants/global';
import instagramPlatformLogo from '../../../assets/images/platforms/platform-instagram.png';
import youtubePlatformLogo from '../../../assets/images/platforms/platform-youtube.png';
import './PlatformSelectionModal.scss';

const platformLogos = {
    ig: instagramPlatformLogo,
    yt: youtubePlatformLogo,
};

interface PlatformSelectionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (platform: string) => void;
    processing?: boolean;
}

const PlatformSelectionModal: React.FC<PlatformSelectionModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    processing = false,
}) => {
    const [selectedPlatform, setSelectedPlatform] = useState('');

    useEffect(() => {
        if (isOpen) {
            setSelectedPlatform('');
        }
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            centered
            className="platform-selection-modal"
            backdrop={processing ? 'static' : true}
        >
            <div className="modal-body">
                <div className="platform-selection-modal__header">
                    <button
                        type="button"
                        className="platform-selection-modal__close"
                        onClick={onClose}
                        disabled={processing}
                        aria-label="Close"
                    >
                        <i className="ri-close-line fs-5" />
                    </button>
                    <h2 className="platform-selection-modal__title">Choose a platform</h2>
                    <p className="platform-selection-modal__subtitle">
                        Select where this campaign will run. You can adjust other campaign details after creation.
                    </p>
                </div>

                <div className="platform-selection-modal__content">
                    <div className="form-group mb-0">
                        <div className="d-flex flex-column">
                            <label htmlFor="campaignPlatform">Platform <span className="text-danger">*</span></label>
                        </div>
                        <div className="logo-radio-tile-group">
                            {Object.values(platforms).map((platform) => (
                                <div
                                    key={platform.id}
                                    className={`logo-radio-tile cursor-pointer ${selectedPlatform === platform.id ? 'active' : ''}`}
                                    onClick={() => !processing && setSelectedPlatform(platform.id)}
                                >
                                    <img
                                        className="h-100"
                                        src={platformLogos[platform.id as keyof typeof platformLogos]}
                                        alt={platform.name}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="platform-selection-modal__footer">
                    <button
                        type="button"
                        className="btn btn-gradient-outline"
                        onClick={onClose}
                        disabled={processing}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-gradient"
                        disabled={!selectedPlatform || processing}
                        onClick={() => onConfirm(selectedPlatform)}
                    >
                        {processing ? 'Creating...' : 'Continue'}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PlatformSelectionModal;
